/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Banner,
  FormLayout,
  Link,
  Modal,
  Text,
  TextField,
} from "@shopify/polaris";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { usePostPasswordChangePinCodeMutation } from "../../store/store/slices/UsersRTK";

const ForgetPassword = () => {
  const [emailSent, setEmailSent] = useState(false);
  const [forgetPasswordModal, setForgetPasswordModal] =
    useState<boolean>(false);
  const [sendEmailGetPin, { isError, error, isLoading }] =
    usePostPasswordChangePinCodeMutation();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const closeModal = () => setForgetPasswordModal(false);
  const onForgetPasswordSubmitHandler = async (formData: FormData) => {
    const resp = await sendEmailGetPin(formData).unwrap();
    if (resp?.email && resp?.message) {
      setEmailSent(() => true);
    } else {
      setEmailSent(() => true);
    }
  };

  return (
    <>
      <Link onClick={() => setForgetPasswordModal(true)}>Forgot password?</Link>
      <Modal
        onClose={closeModal}
        open={forgetPasswordModal}
        title="Account verification"
        primaryAction={{
          content: emailSent ? "Ok" : "Submit",
          onAction: !emailSent
            ? handleSubmit(onForgetPasswordSubmitHandler as any)
            : () => setForgetPasswordModal(false),
          loading: isLoading,
          disabled: isLoading,
        }}
        secondaryActions={[
          { content: "Cancel", onAction: closeModal, disabled: isLoading },
        ]}
      >
        {emailSent ? (
          <Modal.Section>
            <Banner>
              An email has been sent to your mail. Open your mailbox and click
              the link which is sent to your mail
            </Banner>
          </Modal.Section>
        ) : (
          <Modal.Section subdued>
            <FormLayout.Group>
              <Controller
                name="email"
                control={control}
                rules={{ required: "Email is required" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    loading={isLoading}
                    disabled={isLoading}
                    autoComplete="Off"
                    label="Enter email associated to your account"
                    requiredIndicator
                    placeholder="example@bookease.com"
                    error={errors.email && "Email is required"}
                  ></TextField>
                )}
              />
            </FormLayout.Group>
            {isError && (
              <Text as="p" tone="critical">
                {error?.data?.errors[0]?.msg}
              </Text>
            )}
          </Modal.Section>
        )}
      </Modal>
    </>
  );
};

export default ForgetPassword;
